import { useEffect, useState } from 'react';
import { PHONE_LAYOUT_QUERY } from '../phoneLayout';

export default function usePhoneLayout() {
  const [phone, setPhone] = useState(() => typeof window !== 'undefined'
    && typeof window.matchMedia === 'function' && window.matchMedia(PHONE_LAYOUT_QUERY).matches);
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;
    const query = window.matchMedia(PHONE_LAYOUT_QUERY);
    const update = () => setPhone(query.matches);
    update();
    query.addEventListener?.('change', update);
    return () => query.removeEventListener?.('change', update);
  }, []);
  return phone;
}
